import React, { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up event listener on unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    //-top-40 - is not applied when page loads because elements The position: static property prevents top from having an effect. Try setting position to something other than static. after the scroll position is set to fixed then negative value kicks in and smooth navbar is achived
    <nav
      className={`${
        scrolled
          ? "fixed bg-white shadow-md top-[0] transition-all duration-700"
          : ""
      } navbar h-16 w-full flex items-center justify-center z-50 -top-40`}
      //-top-40 is overiding top 0 which scrolled is true alternativly can be done like - ${scrolled ? '' : '-top-40'}
    >
      <div className="navbarContainer w-4/5 flex items-center justify-between">
        <span className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-violet-500 to-purple-500">
          GIRISH
        </span>
        <span className="md:hidden text-3xl">x</span>
        <ul className="hidden md:flex nav-links space-x-10">
          <li>
            <a href="#home" className="font-bold hover:text-violet-800">
              HOME
            </a>
          </li>
          <li>
            <a href="#about" className="font-bold hover:text-violet-800">
              ABOUT
            </a>
          </li>
          <li>
            <a href="#portfolio" className="font-bold hover:text-violet-800">
              PORTFOLIO
            </a>
          </li>
          <li>
            <a href="#contact" className="font-bold hover:text-violet-800">
              CONTACT
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
}
